import React, { useState, useCallback } from 'react';
import PageWithAuth from '../../../../components/PageWithAuth';
import styled from 'styled-components';
import { SimpleLinkButton } from '../../../../components/Buttons';
import Space, { DirectionEnum, SpaceSizesEnum } from '../../../../components/Space/Space';
import signinFigure from '../../../../../public/static/images/signin_figure.png';
import { PageContainer, Title, SigninFigure, StyledSquiggly } from '../../components/AuthPagesLayout';
import ForgotPasswordForm from '../../components/ForgotPasswordForm';
import pagesMeta from '../../../../constants/pages-meta';

const SubTitleContainer = styled.div`
  width: 340px;
  margin-top: 20px;
`;

const SubTitle = styled.p`
  opacity: 0.4;
  font-family: 'Soehne Breit';
  font-size: 14px;
`;

const SuccessMessage = styled.p`
  font-family: 'Soehne Breit';
  font-size: 14px;
  max-width: 300px;
  text-align: left;
`;

type ForgotPasswordState = {
  isReseted: boolean;
  userEmail: string;
};

const ForgotPasswordPage = () => {
  const [state, setState] = useState<ForgotPasswordState>({ isReseted: false, userEmail: '' });

  const onResetHandler = useCallback((userEmail: string) => {
    setState({ isReseted: true, userEmail });
  }, []);

  return (
    <PageWithAuth showWaitList title={pagesMeta.resetPassword.title} description={pagesMeta.resetPassword.description}>
      <PageContainer>
        <Title>Reset Password</Title>
        {!state.isReseted && (
          <SubTitleContainer>
            <SubTitle>Enter your e-mail address and we'll send you a link to reset it.</SubTitle>
            <StyledSquiggly />
          </SubTitleContainer>
        )}
        {!state.isReseted && <ForgotPasswordForm onReset={onResetHandler} />}
        {state.isReseted && (
          <SuccessMessage>
            If a valid email address was entered, please check your email. Instructions to reset your password have been
            sent to {state.userEmail}
          </SuccessMessage>
        )}
        <Space startWith={SpaceSizesEnum.large} direction={DirectionEnum.vertical} />
        <SimpleLinkButton href="/sign-in">Back to sign in</SimpleLinkButton>
        <SigninFigure src={signinFigure} alt="" />
      </PageContainer>
    </PageWithAuth>
  );
};

export default ForgotPasswordPage;
